import { render, staticRenderFns } from "./CTAList.vue?vue&type=template&id=3061607f&"
import script from "./CTAList.vue?vue&type=script&lang=js&"
export * from "./CTAList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports